import {
  Component,
  computed,
  effect,
  forwardRef,
  input,
  model,
  signal,
} from "@angular/core";
import { ChipsComponent } from "../chips/chips.component";
import { MatFormField, MatLabel } from "@angular/material/form-field";
import { MatMenu, MatMenuTrigger } from "@angular/material/menu";
import {
  ControlValueAccessor,
  FormsModule,
  NG_VALUE_ACCESSOR,
} from "@angular/forms";
import { MatDatepickerModule } from "@angular/material/datepicker";
import { MatInputModule } from "@angular/material/input";
import { SharedModule } from "../../shared.module";
import { BigButtonComponent } from "../../components/big-button/big-button.component";

@Component({
  selector: "vl-multi-date",
  standalone: true,
  imports: [
    ChipsComponent,
    MatLabel,
    MatMenu,
    MatMenuTrigger,
    MatFormField,
    MatInputModule,
    MatDatepickerModule,
    FormsModule,
    SharedModule,
    BigButtonComponent,
  ],
  templateUrl: "./multi-date.component.html",
  styleUrl: "./multi-date.component.scss",
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => MultiDateComponent),
      multi: true,
    },
  ],
})
export class MultiDateComponent implements ControlValueAccessor {
  text = input<string>();
  value = model<{ start: Date; end: Date }>(null);
  startLabel = input("Date minimum");
  endLabel = input("Date maximum");

  startDate = signal<Date>(null);
  endDate = signal<Date>(null);

  buttonState = computed(() =>
    this.value()?.start || this.value()?.end ? "active" : "enabled",
  );

  onChangeFn = (v) => {};
  onTouchFn = (v) => {};

  constructor() {
    effect(() => {
      //this.emitChanges(val);
    });
  }

  registerOnChange(fn: any): void {
    this.onChangeFn = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouchFn = fn;
  }

  writeValue(obj: any): void {
    this.value.set(obj);
  }

  onValid() {
    this.updateValue();
    this.onChangeFn(this.value());
  }

  onCancel() {
    this.startDate.set(this.value().start);
    this.endDate.set(this.value().end);
  }

  updateValue() {
    this.value.set({ start: this.startDate(), end: this.endDate() });
  }

  onClear() {
    this.startDate.set(null);
    this.endDate.set(null);
  }
}
